import FormDialog from '../form/form-dialog';
import http from '../utils/http';

import React from 'react';

const EnvironmentDeleteModal = (props) => {
    const {
        config,
        isOpen,
        onChange,
        onChangeBulk,
        applicationId,
        environmentName,
        environmentId
    } = props;
    return (
        <FormDialog
            dialogTitle={`Delete "${environmentName}" Environment?`}
            dialogSubHeading={'WARNING: Deleting an environment will cause any network traffic to fail for the environment as well as prevent application startup. Are you sure?'}
            submitButtonText={'DELETE'}
            handleClose={() => onChange(false, 'environmentDeleteModalIsOpen')}
            handleSubmit={async () => {
                await http.delete({}, `${config.uri.base}/environment/${environmentId}`);
                const environments = await http.get({
                    applicationId
                }, `${config.uri.base}/environment`);
                onChangeBulk({
                    environmentDeleteModalIsOpen: false,
                    environments: environments.rows,
                });
            }}
            isOpen={isOpen}
        >
        </FormDialog>
    );
};

export default EnvironmentDeleteModal;
